module.exports = __webpack_public_path__ + "static/media/payment.dbf0f104.svg";